import type { ReactNode } from "react"
import { useAuth } from "@/contexts/AuthContext"
import { TermsAndConditionsModal } from "@/components/TermsAndConditionsModal"

type TermsAcceptanceGateProps = {
  children: ReactNode
}

export function TermsAcceptanceGate({ children }: TermsAcceptanceGateProps) {
  const { user, acceptTerms } = useAuth()
  const needsAcceptance = Boolean(user && !user.termsAcceptedAt)

  return (
    <>
      {children}
      {needsAcceptance ? (
        <TermsAndConditionsModal onAccept={acceptTerms} />
      ) : null}
    </>
  )
}
